import createDuck, {createThunk} from '../utils/actions';
import axios from '../net/axios';
import config from '../config';

const baseUrl = config.api.baseUrl;

const parametroGetDuck = createDuck('PARAMETRO_GET');

const parametroGetThunk = params => {
  const url = `${baseUrl}/v1/parametro/${params.id}`;

  return createThunk(axios, 'get', parametroGetDuck.actions, url, null, params);
};

const parametrosGetDuck = createDuck('PARAMETROS_GET');

const parametrosGetThunk = params => {
  const url = `${baseUrl}/v1/parametros`;

  return createThunk(
    axios,
    'get',
    parametrosGetDuck.actions,
    url,
    null,
    params,
  );
};

const parametroEditDuck = createDuck('PARAMETRO_EDIT');

const parametroEditThunk = params => {
  const url = `${baseUrl}/v1/parametro/${params.id}`;
  return createThunk(axios, 'patch', parametroEditDuck.actions, url, params);
};

export {
  parametroGetDuck,
  parametroGetThunk,
  parametrosGetDuck,
  parametrosGetThunk,
  parametroEditDuck,
  parametroEditThunk,
};
